import { commitMutation,
  graphql } from 'react-relay';
import environment from '../../.';
import { basicMutationOnCompleted, onErrorMutation, updaterBasicDelete } from '../common/common';

const mutation = graphql`
  mutation DeleteDocumentsMutation($documentsIds: [ID]!) {
    deleteDocuments(documentsIds: $documentsIds) {
      ok
      error
    }
  }
`;

export default ({
  documentsIds
}, done) => {
  const variables = { documentsIds };

  commitMutation(
    environment(),
    {
      mutation,
      variables,
      updater: (proxyStore, { deleteDocuments: { ok, error } }) => updaterBasicDelete(proxyStore, ok, error, documentsIds),
      onCompleted: ({ deleteDocuments }) => basicMutationOnCompleted(deleteDocuments, done),
      onError: error => onErrorMutation(error, done)
    }
  );
};
